import { Info } from 'lucide-react'
import { Trans, useTranslation } from 'react-i18next'
import { PageHeader } from '@/components/shared/page-header'
import { SegmentsTab } from '@/pages/cdp/segments-tab'
import { CustomersTabs } from './customers-tabs'

/** Tab "Phân khúc" của Khách hàng (/customers/segments, quyền cdp.view). Thuộc tính / sự kiện / vòng đời nằm ở Cài đặt → Dữ liệu khách hàng. */
export function SegmentsPage() {
  const { t } = useTranslation('custList')
  return (
    <div className="space-y-5">
      <CustomersTabs />
      <PageHeader
        title={t('segmentsPage.title')}
        description={t('segmentsPage.description')}
      />
      <div className="flex gap-2 rounded-md border bg-muted/40 p-3 text-sm text-muted-foreground">
        <Info className="mt-0.5 h-4 w-4 shrink-0" />
        <p>
          <Trans t={t} i18nKey="segmentsPage.hint" components={{ b: <b /> }} />
        </p>
      </div>
      <SegmentsTab />
    </div>
  )
}
